<script setup>
import {ref, watch} from 'vue'

const props = defineProps({
  message: Object,
  width: String,
  height: String
})
const emit = defineEmits(['openLightbox'])
const isLoaded = ref(false)

const handleLoad = () => {
  isLoaded.value = true
}

function openLightbox() {
  emit('openLightbox')
}

watch(
    () => props.message?.pending,
    (newVal) => {
      if (newVal) {
        isLoaded.value = true
      }
    },
    {immediate: true}
)
</script>

<template>
  <div class="relative cursor-pointer" :style="{ width, height }" @click="openLightbox">
    <template v-if="!message.pending">
      <div v-show="!isLoaded"
           class="w-full min-w-72 h-48 bg-slate-300 inset-0 flex items-center justify-center animate-pulse">
        <span class="text-gray-500">Loading . . .</span>
      </div>
      <img
          v-show="isLoaded"
          :src="message.file.url"
          :alt="message.file.name"
          class="w-full h-full object-cover transition-opacity duration-500 max-h-[20vh]"
          @load="handleLoad"
      />
    </template>

    <template v-else>
      <img
          :src="message.file.url"
          :alt="message.file.name"
          class="w-full h-full object-cover max-h-[20vh]"
      />
      <div
          class="absolute inset-0 bg-black/40 flex items-center justify-center text-white text-sm font-medium">
        Uploading...
      </div>
    </template>
  </div>
</template>

<style scoped>
.animate-pulse {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}
</style>